import { DynamoDBClient } from "@aws-sdk/client-dynamodb";
import {
  DynamoDBDocumentClient,
  GetCommand,
} from "@aws-sdk/lib-dynamodb";
import { fetchAuthSession } from "aws-amplify/auth";

// env
const {
  REACT_APP_REGION,
  REACT_APP_PARTNERS_TABLENAME,
} = process.env;

const queryTable = async (awsCredentials, { userId }) => {

  const docClient = DynamoDBDocumentClient.from(
    new DynamoDBClient({
      region: REACT_APP_REGION,
      credentials: awsCredentials,
    })
  );

  // build command
  const command = new GetCommand({
    TableName: REACT_APP_PARTNERS_TABLENAME,
    Key: {
      account_id: userId,
      resource_id: 'SELF',
    },
    ProjectionExpression: '\
        #account_id, \
        #resource_id, \
        #individual, \
        #agreement, \
        #date_of_birth, \
        #application_location, \
        #status, \
        #user_id, \
        #enabled, \
        #account_type, \
        #stripe_account_id, \
        #stripe_account, \
        #payment_account, \
        #electrical_competency, \
        #driving_license, \
        #vehicle, \
        #registration_toolkit, \
        #completion, \
        #created, \
        #modified',
    ExpressionAttributeNames: {
      '#account_id': 'account_id',
      '#user_id': 'user_id',
      '#resource_id': 'resource_id',
      '#individual': 'individual',
      '#application_location': 'application_location',
      '#date_of_birth': 'date_of_birth',
      '#agreement': 'agreement',
      '#status': 'status',
      '#enabled': 'enabled',
      '#account_type': 'account_type',
      '#stripe_account_id': 'stripe_account_id',
      '#stripe_account': 'stripe_account',
      '#payment_account': 'payment_account',
      '#electrical_competency': 'electrical_competency',
      '#driving_license': 'driving_license',
      '#vehicle': 'vehicle',
      '#registration_toolkit': 'registration_toolkit',
      '#completion': 'completion',
      '#created': 'created',
      '#modified': 'modified',
    },
  });

  const res = await docClient.send(command);
  return res.Item;
}

const handler = async ({ user_id }, { getState, rejectWithValue }) => {
  try {
    console.log('services.partners.getPartnerAccount@handler', 'user_id', user_id);

    // get credentials
    const { credentials } = await fetchAuthSession();

    const res = await queryTable(credentials, { userId: user_id });
    console.log('services.partners.getPartnerAccount@handler', 'res', res);
    return res;

  } catch (error) {
    console.error('services.partners.getPartnerAccount@handler', error);
    return rejectWithValue(error);
  }
}

const pending = (state, action) => {
  return {
    ...state,
  };
}

const fulfilled = (state, action) => {
  return {
    ...state,
    ...action.payload,
  };
}

const rejected = (state, action) => {
  return {
    ...state,
  };
}

export default {
  handler,
  pending,
  fulfilled,
  rejected
}